import React from 'react';
import WrapperSection from '../../components/global/WrapperSection';
import GlobalBreadcrumbs from '../../components/global/GlobalBreadcrumbs';
import OrgStructureAssignmentsTable from '../../components/orgStructureAssignments/OrgStructureAssignmentsTable';

const OrgStructureAssignments = () => (<WrapperSection><GlobalBreadcrumbs /><OrgStructureAssignmentsTable /></WrapperSection>);
export default OrgStructureAssignments;
